import React, { useCallback } from 'react'
import { makeStyles } from '@material-ui/styles'
import { Trans, useTranslation } from 'react-i18next'
import { Grid } from '@material-ui/core'
import DazzedParagraph16 from 'components/common/text/DazzedParagraph16'
import { trackEvent } from 'utils/analyticsUtils'
import ToggledOffStateIcon from '../Icons/ToggledOffStateIcon'

const useStyles = makeStyles(theme => ({
  link: {
    fontSize: 16,
    color: 'var(--text-color-25)',
    textDecoration: 'underline',
    cursor: 'pointer'
  }
}))

const NotificationCenterToggledOffState = () => {
  const classes = useStyles()
  const { t } = useTranslation()

  const handleOpenSettingsClicked = useCallback(() => {
    trackEvent('Notification Center - toggled off state - open settings clicked')
    window.open(window.location.origin + '/profile/account-settings/notification-settings', '_blank')
  }, [])

  return (
    <Grid container direction="column" alignItems="center" justifyContent="center" style={{ height: '100%' }}>
      <Grid item style={{ marginBottom: 8 }}>
        <ToggledOffStateIcon />
      </Grid>
      <Grid item>
        <DazzedParagraph16 bold>{t('dialogs.notificationCenterDialog.toggledOffState.title')}</DazzedParagraph16>
      </Grid>
      <Grid item>
        <DazzedParagraph16 strong>
          <Trans
            i18nKey={'dialogs.notificationCenterDialog.toggledOffState.subtitle'}
            components={{
              a: <span onClick={handleOpenSettingsClicked} className={classes.link} />
            }}
          />
        </DazzedParagraph16>
      </Grid>
    </Grid>
  )
}

export default NotificationCenterToggledOffState
